<template>
	<Accordion
		:open="open"
		:title="title"
		:disabled="disabled"
		:disabled-hint="disabledHint"
		@toggle="onToggle"
	>
		<div
			v-if="info"
			class="info"
			:class="{'is-mobile': isMobileWebApp}"
		>
			<div class="info--lead">
				<Icon
					icon-name="c-info"
					size="sm"
				/>
			</div>
			<div class="info--body">
				{{ info }}
			</div>
		</div>
		<TagButtons
			:tags="tags"
			:squared-buttons="squaredButtons"
			:align-buttons="alignButtons"
			@tag-click="onTagClick"
		/>
	</Accordion>
</template>

<script>
import Accordion from '@components/accordion/Accordion';
import TagButtons from '@videotools/js/one/components/TagCenter/TagButtons';
import { mapGetters } from 'vuex';

export default {
	name:       'CustomTagsSection',
	components: { TagButtons, Accordion },
	props:      {
		open: {
			type:	Boolean,
		},
		title: {
			type:	String,
		},
		disabled: {
			type:	Boolean,
		},
		disabledHint: {
			type:	String,
		},
		tags: {
			type:	Array,
		},
		info: {
			type: String,
		},
		squaredButtons: {
			type: Boolean,
		},
		alignButtons: {
			type: String,
		},
	},
	computed: {
		...mapGetters({
			isMobileWebApp: 'app/isMobileWebApp',
		}),
	},
	methods: {
		onTagClick(tag) {
			this.$emit('tag-click', tag);
		},
		onToggle(open) {
			this.$emit('toggle', open);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import "@videotools/sass/_fonts.scss";

.info {
	display: flex;
	align-items: flex-start;
	color: var(--color-grey-300);
	@include text-sm-2;
	margin-bottom: 24px;
	margin-top: -16px;

	&.is-mobile {
		margin-top: 0;
	}

	&--lead {
		padding: 3px 8px 3px 0;
	}
}
</style>
